<mat-toolbar class="lot-edit-bulk-actions">
  <div class="container">
    <div class="row">
      <div class="col-xs-10">
        <ng-container *ngIf="hasFulfillmentCreation | async">
          <button [disabled]="!bulkActionsActive" [matMenuTriggerFor]="editMenu" class="box-shadow-none btn-custom margin-right-6">
            <i class="fa fa-pencil" aria-hidden="true"></i> Edit
          </button>

          <mat-menu #editMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMenu">
              Change Status <i class="fa fa-angle-right sel-icon" aria-hidden="true"></i>
            </button>
            <mat-menu #statusMenu="matMenu">
              <button mat-menu-item *ngFor="let s of spoStatusArray" (click)="changeStatus(s.code)">{{ s.description }}</button>
            </mat-menu>

            <button mat-menu-item [matMenuTriggerFor]="changePaymentMenu">
              Payment status <i class="fa fa-angle-right sel-icon" aria-hidden="true"></i>
            </button>
            <mat-menu #changePaymentMenu="matMenu">
              <button mat-menu-item (click)="setPayment(true)">Paid</button>
              <button mat-menu-item (click)="setPayment(false)">Not paid</button>
            </mat-menu>

            <button mat-menu-item [disabled]="!bulkActionsActive" (click)="merge()">
              <i class="fa fa-compress margin-right-6" aria-hidden="true"></i>Merge
            </button>

            <button mat-menu-item [disabled]="!bulkActionsActive" (click)="delete()">
              <i class="fa fa-trash margin-right-6" aria-hidden="true"></i>Delete
            </button>
          </mat-menu>

          <button [matMenuTriggerFor]="importResponseMenu" class="box-shadow-none btn-custom margin-right-6">
            <i class="fa fa-upload margin-right-6" aria-hidden="true"></i> Import
          </button>
          <mat-menu #importResponseMenu="matMenu">
            <button mat-menu-item (click)="importSpoResponse()">
              <i class="fa fa-check-square-o margin-right-6" aria-hidden="true"></i> SPO confirmation
            </button>
            <button mat-menu-item (click)="importSpoGenerate()">
              <i class="fa fa-plus margin-right-6" aria-hidden="true"></i>Generate SPOs
            </button>
            <button mat-menu-item (click)="importUpdateOrdered()">
              <i class="fa fa-list-ol margin-right-6" aria-hidden="true"></i>Update ordered
            </button>
          </mat-menu>

          <button class="box-shadow-none btn-custom margin-right-6" [disabled]="!bulkActionsActive" (click)="sendSpos()">Send</button>

          <button [disabled]="!bulkActionsActive" (click)="generateShipments()" class="box-shadow-none btn-custom margin-right-6">
            Generate shipments
          </button>
        </ng-container>

        <input #getSpoResp type="file" style="display: none;" onclick="this.value = null" (change)="uploadSpoResponse($event)" />
        <input #getSpoGenerate type="file" style="display: none;" onclick="this.value = null" (change)="uploadSpoGenerate($event)" />
        <input #getUpdateOrdered type="file" style="display: none;" onclick="this.value = null" (change)="uploadUpdateOrdered($event)" />
      </div>

      <div class="col-xs-2 text-right">
        <button [disabled]="!bulkActionsActive" [matMenuTriggerFor]="exportChoice" class="box-shadow-none btn-custom">
          Export selected rows
        </button>
        <mat-menu #exportChoice="matMenu">
          <button mat-menu-item (click)="exportExcel('excel')">Save as Excel</button>
          <button mat-menu-item (click)="exportExcel('csv')">Save as CSV</button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>
